import { Button, Cascader, Col, Divider, Form, Input, Row, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { Card, CardBody } from 'reactstrap'
import './style.css'
import { SearchOutlined } from '@ant-design/icons';
import { getRequestApiByToken } from '../../../../api';
import Typography from 'antd/lib/typography/Typography';
const { Search } = Input;

const AdvanceSerchForm = ({la_sectorData=[],la_practices=[],la_country=[],la_clientName=[],handleMultiSearch=()=>{}, lb_loading,lb_isAdvanceSearch=false, la_documentCategory, la_documentSubCategory, setDocumentSubCategory,form, lb_isFileSearch}) => {
    
    const getDocumentSubCategoryData = async (item) => {
        setDocumentSubCategory(item?.subcategory || [])
    }
    const getTopSearchDynamicRowWidth = () => {
        let colValue = 0;
        if (lb_isAdvanceSearch && lb_isFileSearch) {
            colValue = 21;
        } else if (!lb_isAdvanceSearch && lb_isFileSearch) {
            colValue = 18;
        } else if (lb_isAdvanceSearch && !lb_isFileSearch) {
            colValue = 24;
        } else if (!lb_isAdvanceSearch && !lb_isFileSearch) {
            colValue = 21;
        }
        return colValue;
    }
    
  return (
    <>
        <Card>
            <CardBody>
                <Form
                    //   form={form}
                    className="theme-form"
                    labelCol={{ span: 24 }}
                    onFinish={handleMultiSearch}
                >
                    <Row gutter={[6]}>

                        {/* <div className={`col-xl-12 xl-100 col-sm-12 mb-2`} >
                            <Typography.Text>Search other document (Mandate no / Document name)</Typography.Text>
                        </div> */}

                        <Col xs={24} sm={getTopSearchDynamicRowWidth()} md={getTopSearchDynamicRowWidth()} lg={getTopSearchDynamicRowWidth()}>

                            <Form.Item name='search' label="Search other document (Mandate no / Document name)">
                                <Input allowClear placeholder="Mandate no / Document name" suffix={lb_isAdvanceSearch && <SearchOutlined style={{ color: 'rgba(0,0,0,.45)', }} />} />
                            </Form.Item>
                        </Col>

                        {lb_isFileSearch ?
                        <Col xs={24} sm={3} md={3} lg={3}>
                            <Row gutter={[6]}>
                                <Col xs={24} sm={24} md={24} lg={24}>
                                    <Form.Item name="fileSearchType" label='Search Type'>
                                        <Select placeholder="Select Search Type" defaultValue={"exact"} style={{ width: '100%' }}>
                                            <Select.Option value="exact" key='exact'>Exact Search</Select.Option>
                                            <Select.Option value="nlp" key='nlp'>Similar search</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                        : <></>}

                        {!lb_isAdvanceSearch &&
                            <Col xs={24} sm={3} md={3} lg={3}>
                                <div style={{marginTop:1.6}} >
                                    <Button
                                        loading={lb_loading}
                                        icon={<i className="fa fa-search" style={{ color: 'white' }} />}
                                        className="btn btn-primary button-style"
                                        type="button"
                                        htmlType='submit'
                                        style={{ marginInlineStart: 3, width: '98%' }}
                                    ></Button>
                                </div>
                            </Col>
                        }
                    </Row>
                    {lb_isAdvanceSearch &&
                        <Row gutter={[6]}>

                            <Col xs={24} sm={8} md={8} lg={8}>
                                <Form.Item
                                    label="Sectors"
                                    name="sector_id"
                                >
                                    <Select
                                        placeholder="Select Sectors"
                                        mode="multiple"
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                        }
                                    >
                                        {la_sectorData.map(sector => (
                                            <Select.Option key={sector.value} value={sector.value}>
                                                {sector.label}
                                            </Select.Option>
                                        ))}
                                    </Select>

                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={8} md={8} lg={8}>
                                <Form.Item
                                    label="Practices"
                                    name="parctices"
                                >
                                    <Select placeholder="Select Practices"
                                        // options={la_practices}
                                        mode='multiple'
                                        allowClear showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                        }
                                    >
                                        {la_practices?.map(practices => (
                                            <Select.Option key={practices.value} value={practices.value}>
                                                {practices.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={8} md={8} lg={8}>
                                <Form.Item
                                    label="Client"
                                    name="donor"
                                >
                                    <Select placeholder="Select Client"
                                        // options={la_clientName}
                                        mode='multiple'
                                        allowClear showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                        }
                                    >
                                        {la_clientName?.map(clientName => (
                                            <Select.Option key={clientName.value} value={clientName.value}>
                                                {clientName.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            {/* <Col xs={24} sm={20} md={20} lg={20}> */}
                            <Col xs={24} sm={8} md={8} lg={8}>
                                <Form.Item
                                    label="Document Category"
                                    name="category_id"
                                //   rules={[{ required: true,  message: "Please input Document Category!"}]}
                                >
                                    <Select placeholder="Select Document Category"
                                        onChange={(value, event) => { getDocumentSubCategoryData(event) }}
                                        allowClear showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                        }
                                    >
                                        {la_documentCategory?.map(rowValue => (
                                            <Select.Option key={rowValue.id} value={rowValue.id} subcategory={rowValue?.children || []}>
                                                {rowValue.category_name}
                                            </Select.Option>
                                        ))}
                                    </Select>

                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={8} md={8} lg={8}>
                                <Form.Item
                                    label="Tag"
                                    name="key_words"
                                    style={{ marginInlineEnd: 3 }}
                                >
                                    <Select
                                        mode="tags"
                                        style={{ width: '100%' }}
                                        placeholder="Tags Mode"
                                        //   onChange={handleTagSelect}
                                        options={[]}
                                    />
                                </Form.Item>
                            </Col>

                            <div className="col-xl-4 xl-100 col-sm-12 serchdoc-btn"  >
                                <Button
                                    loading={lb_loading}
                                    icon={<i className="fa fa-search" style={{ color: 'white' }} />}
                                    className="btn btn-primary button-style"
                                    type="button"
                                    htmlType='submit'
                                    style={{ marginInlineStart: 3 }}
                                >Search</Button>
                            </div>
                        </Row>
                    }
                </Form>
            </CardBody>
        </Card>
    </>
  )
}

export default AdvanceSerchForm